import { DashboardPalette } from 'src/constants/dashboard';

// maintain order - green FROM the brightest, then gray TO the brightest
export const DASHBOARD_ACTIVE_RECORDS_COLORS = [
  DashboardPalette.green400,
  DashboardPalette.green350,
  DashboardPalette.green300,
  DashboardPalette.green250,
  DashboardPalette.green200,
  DashboardPalette.grey50,
  DashboardPalette.grey100,
  DashboardPalette.grey150,
  DashboardPalette.grey200,
  DashboardPalette.grey250,
  DashboardPalette.grey300,
  DashboardPalette.grey350,
  DashboardPalette.grey400,
];
